// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-container {
  overflow: auto;
  min-height: 100px;
  max-height: 200px;
}
.open .ql-container  {
    max-height: fit-content !important;
}
.ql-editor {
  min-height: 100px;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0px 0 10px;
  font-size: initial;
  text-align: initial !important;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  border-radius: 0px 0px 10px 10px;
  border: 0;
  border-top: 1px solid #d2d2d6;
}
.ql-toolbar.ql-snow {
  border-radius: 10px 10px 0px 0px;
  z-index: 10001;
  border: 0;
}
.ql-container {
  overflow: auto;
  min-height: 100px;
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/core/editor/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;;;;;;EAWE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".ql-container {\n  overflow: auto;\n  min-height: 100px;\n  max-height: 200px;\n}\n.open .ql-container  {\n    max-height: fit-content !important;\n}\n.ql-editor {\n  min-height: 100px;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0px 0 10px;\n  font-size: initial;\n  text-align: initial !important;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n  border-radius: 0px 0px 10px 10px;\n  border: 0;\n  border-top: 1px solid #d2d2d6;\n}\n.ql-toolbar.ql-snow {\n  border-radius: 10px 10px 0px 0px;\n  z-index: 10001;\n  border: 0;\n}\n.ql-container {\n  overflow: auto;\n  min-height: 100px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
